import axios from 'axios';

import { setNotificationMessage } from '../../redux/slices/NotificationManagementSlice';
import { store } from '../../redux/store';
// import { removeCookie } from '../../shared-functions/Cookies';
import { removeLocalStorageItem } from '../../shared-functions/LocalStorage';

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // Clear the authentication token
      // removeCookie('ev-access-token');
      removeLocalStorageItem('ev-access-token');
      removeLocalStorageItem('partnerName');
      removeLocalStorageItem('accountCustomId');

      // Dispatch 401 error to Redux
      // This will trigger the redirect logic in Router.tsx
      store.dispatch(
        setNotificationMessage({
          status: true,
          message: 'Session expired. Please login again.',
          type: 'error',
          code: 401,
        }),
      );
    }
    return Promise.reject(error);
  },
);
